import Testimonials from '../views/Testimonials';
import Results from '../views/Results';
import Blog from '../views/Blog';
import Videos from '../views/Videos';
import VideoSeries from '../views/VideoSeries';
import Page from '../views/Page';

/**
 * This is a variables containing the ENDPOINTS for our PHP Endpoints
 * Follow the structure: 'post-type': 'endpointURL'
 */
const API = {
  testimonial: {
    endpoint: 'api/testimonials',
    view: Testimonials,
  },
  result: {
    endpoint: 'api/results',
    view: Results,
  },
  blog: {
    endpoint: 'api/blog',
    view: Blog,
  },
  cw_video: {
    endpoint: 'api/videos',
    view: Videos,
  },
  video_series: {
    endpoint: 'api/videoseries',
    view: VideoSeries,
  },
  post: {
    endpoint: 'api/post',
    view: Page,
  },
};

export default API;
